export function useHashScroll(page: HTMLElement) {
  if (window.location.hash) {
    const id = window.location.hash.replace('#', '');
    const el = page.querySelector(`#${id}`);
    if (!el) return;
    const y = (el as HTMLElement).offsetTop - 150;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}
